export const languages = {
  "eng": [
      "英语",
      "English"
  ],
  "ger": [
      "德语",
      "German"
  ],
  "fre": [
      "法语",
      "French"
  ],
  "rus": [
      "俄语",
      "Russian"
  ],
  "jpn": [
      "日语",
      "Japanese"
  ],
  "spa": [
      "西班牙语",
      "Spanish"
  ],
  "chi": [
      "中文",
      "Chinese"
  ],
  "ita": [
      "意大利语",
      "Italian"
  ],
  "pol": [
      "波兰语",
      "Polish"
  ],
  "por": [
      "葡萄牙语",
      "Portuguese"
  ],
  "cze": [
      "捷克语",
      "Czech"
  ],
  "dut": [
      "荷兰语",
      "Dutch"
  ],
  "dan": [
      "丹麦语",
      "Danish"
  ],
  "swe": [
      "瑞典语",
      "Swedish"
  ],
  "hun": [
      "匈牙利语",
      "Hungarian"
  ],
  "nor": [
      "挪威语",
      "Norwegian"
  ],
  "rum": [
      "罗马尼亚语",
      "Romanian, Rumanian, Moldovan"
  ],
  "bul": [
      "保加利亚语",
      "Bulgarian"
  ],
  "hrv": [
      "克罗地亚语",
      "Croatian"
  ],
  "ukr": [
      "乌克兰语",
      "Ukrainian"
  ],
  "heb": [
      "希伯来语",
      "Hebrew"
  ],
  "fin": [
      "芬兰语",
      "Finnish"
  ],
  "srp": [
      "塞尔维亚语",
      "Serbian"
  ],
  "slo": [
      "斯洛伐克语",
      "Slovak"
  ],
  "tur": [
      "土耳其语",
      "Turkish"
  ],
  "kor": [
      "韩语",
      "Korean"
  ],
  "gre": [
      "希腊语",
      "Greek, Modern"
  ],
  "afr": [
      "南非语",
      "Afrikaans"
  ],
  "ice": [
      "冰岛语",
      "Icelandic"
  ],
  "lit": [
      "立陶宛语",
      "Lithuanian"
  ],
  "tha": [
      "泰语",
      "Thai"
  ],
  "slv": [
      "斯洛文尼亚语",
      "Slovenian"
  ],
  "bos": [
      "波斯尼亚语",
      "Bosnian"
  ],
  "ara": [
      "阿拉伯语",
      "Arabic"
  ],
  "ind": [
      "印度尼西亚语",
      "Indonesian"
  ],
  "per": [
      "波斯语",
      "Persian, Iranian"
  ],
  "cat": [
      "加泰罗尼亚语",
      "Catalan"
  ],
  "aze": [
      "阿塞拜疆语",
      "Azerbaijani"
  ],
  "mac": [
      "马其顿语",
      "Macedonian"
  ],
  "lat": [
      "拉丁语",
      "Latin"
  ],
  "epo": [
      "世界语",
      "Esperanto"
  ],
  "alb": [
      "阿尔巴尼亚语",
      "Albanian"
  ],
  "arm": [
      "亚美尼亚语",
      "Armenian"
  ],
  "geo": [
      "格鲁吉亚语",
      "Georgian"
  ],
  "may": [
      "马来语",
      "Malay"
  ],
  "hin": [
      "印地语",
      "Hindi"
  ],
  "est": [
      "爱沙尼亚语",
      "Estonian"
  ],
  "lav": [
      "拉脱维亚语",
      "Latvian"
  ],
  "wel": [
      "威尔士语",
      "Welsh"
  ],
  "kin": [
      "卢旺达语",
      "Kinyarwanda"
  ],
  "vie": [
      "越南语",
      "Vietnamese"
  ],
  "gla": [
      "苏格兰盖尔语",
      "Scottish Gaelic"
  ],
  "pus": [
      "普什图语",
      "Pushto"
  ],
  "mao": [
      "毛利语",
      "Maori"
  ],
  "san": [
      "梵语",
      "Sanskrit"
  ],
  "mal": [
      "马拉雅拉姆语",
      "Malayalam"
  ],
  "amh": [
      "阿姆哈拉语",
      "Amharic"
  ]
}

export const publications = {
  "Review": "综述",
  "Case Reports": "病例报告",
  "Comparative Study": "比较研究",
  "Letter": "Letter",
  "Comment": "评述",
  "Editorial": "社论",
  "Randomized Controlled Trial": "随机对照试验",
  "Clinical Trial": "临床试验",
  "Multicenter Study": "多中心研究",
  "Systematic Review": "系统综述",
  "News": "新闻",
  "Evaluation Studies": "评价研究",
  "Meta": "meta分析",
  "Observational Study": "观察性研究",
  "Published Erratum": "勘误",
  "Controlled Clinical Trial": "控制性临床试验",
  "Validation Studies": "验证性研究",
  "Evaluation Study": "评价研究",
  "Clinical Trial, Phase II": "2期临床试验",
  "Practice Guideline": "临床指南",
  "Validation Study": "验证性研究",
  "Clinical Trial, Phase I": "1期临床试验",
  "Clinical Trial, Phase III": "3期临床试验",
  "Guideline": "指南",
  "Retraction of Publication": "撤稿",
  "Retracted Publication": "撤稿",
  "Clinical Trial Protocol": "临床试验方案",
  "Twin Study": "双生子研究",
  "Clinical Conference": "临床讨论",
  "Clinical Study": "临床研究",
  "Randomized Controlled Trial, Veterinary": "兽医随机对照试验",
  "Clinical Trial, Phase IV": "4期临床试验",
  "Pragmatic Clinical Trial": "实用性临床试验",
  "Clinical Trial, Veterinary": "兽医临床试验",
  "Equivalence Trial": "平行对照试验",
  "Observational Study, Veterinary": "兽医观察性研究",
  "Adaptive Clinical Trial": "适应性临床试验"
}

/**
 * 研究列表页过滤器中英文
 */
export const clinicalTrialsFilters = {
    "Completed": "已完成",
    "Recruiting": "招募中",
    "Enrolling by invitation": "指定招募",
    "Not yet recruiting": "尚未招募",
    "Active not recruiting": "目前不招募",
    "Suspended": "暂停",
    "Withheld": "保留",
    "Withdrawn": "已撤销",
    "Terminated": "已终止",
    "Approved for marketing": "市场准入",
    "Available": "可行",
    "Temporarily not available": "暂不可行",
    "No longer available": "不再可行",
    "Unknown": "未知",
    "Interventional": "干预性研究",
    "Observational": "观察性研究",
    "Expanded access": "拓展性应用",
    "Early Phase1": "0期",
    "Phase1": "Ⅰ期",
    "Phase2": "Ⅱ期",
    "Phase3": "Ⅲ期",
    "Phase4": "Ⅳ期",
    "Primary": "主要结局",
    "Secondary": "次要结局",
    "Other": "其他",
    "DEVICE": "器械",
    "BEHAVIORAL": "行为干预",
    "PROCEDURE": "手术操作",
    "COMBINATION_PRODUCT": "药械组合产品",
    "DIAGNOSTIC_TEST": "诊断测试",
    "OTHER": "其他",
    "DRUG": "药物",
    "BIOLOGICAL": "生物制剂",
    "GENETIC": "基因干预",
    "RADIATION": "放射疗法",
    "DIETARY_SUPPLEMENT": "营养补充剂"
}

/**
 * 研究详情页的section 中英文
 */
export const clinicalTrialsSectionName = {
    "ClinicalTrials.gov ID": "注册号",
    "Sponsor": "赞助商",
    "Last Update Posted": "最近更新日期",
    "Study Overview": "研究概览",
    "Brief Summary": "检验总结",
    "Official Title": "正式标题",
    "Conditions": "研究疾病",
    "Intervention / Treatment": "干预方案",
    "Study Start": "研究开始",
    "Study Completion": "研究完成",
    "Study Type": "研究类型",
    "Phase": "临床试验阶段",
    "Participation Criteria": "参与标准",
    "Eligibility Criteria": "纳排标准",
    "Description": "描述",
    "Ages Eligible for Study": "年龄要求",
    "Sexes Eligible for Study": "性别要求",
    "Study Plan": "研究方案",
    "Design Details": "研究设计",
    "Primary Purpose": "主要目的",
    "Allocation": "分配",
    "Interventional Model": "干预模型",
    "Observational Model": "观察模型",
    "Time Perspective": "时间视角",
    "Masking": "盲法",
    "Outcome": "研究结局",
    "Outcome Measures": "结局",
    "Primary Outcome Measures": "主要结局",
    "Secondary Outcome Measures": "次要结局",
    "Other Outcome": "其他结局"
}


// WEBPACK FOOTER //
// ./src/utils/articleTags.js